{{#if items}}
<div class="row p-b-10">
	<div class="col-xs-12">
		<h4 class="page-title">{{TR "Verbindungsstatistik"}}</h4>
		<p class="m-t-5">{{TR "Die angezeigten Werte zum Datenvolumen basieren auf Messungen und Schätzungen. Der tatsächliche Datenverbrauch kann abweichen."}}</p>
	</div>
</div>
<div id="js-overview" class="row-layout-2-3-3"></div>
{{/if}}

<div class="row p-b-10">
	<div class="col-xs-12">
		<h4 id="ct-reportData-heading" class="page-title js-abstract-table-title">{{TR "Verbindungsdaten"}}</h4>
	</div>
</div>

{{#if showFilter}}
<div class="row">
	<div class="col-xs-12">
		<div class="card-box clearfix">
			{{{FILTER filter}}}
		</div>
	</div>
</div>
{{/if}}

<div class="row">
	{{#if items}}
	<div class="col-xs-12" id="js-table" ></div>
	{{else}}
	<div class="col-xs-12">
		<div class="card-box clearfix ">
			{{#if showFilter}}
			<h3 id="ct--heading">{{TR "Keine Geräte gefunden"}}</h3>
			<p>{{TR "Es wurden keine Geräte gefunden, die Ihrer Filtereinstellung entsprechen."}}</p>
			<a href="#" class="btn btn-primary m-t-30 js-reset-filter">{{TR "Filter zurücksetzen"}}</a>
			{{else}}
			<h3 id="ct--heading">{{TR "Keine Informationen vorhanden"}}</h3>
			<p>{{TR "Aktuell wurden noch keine Kommunikationsdaten erfasst."}}</p>
			{{/if}}
		</div>
	</div>
	{{/if}}
</div>

